export const cilInputPower = ["24 24","<path d='M16.875 5.625v-4.875h-1.5v4.875h-6.75v-4.875h-1.5v4.875h-3v8.953l4.875 4.5v4.172h6v-4.172l4.875-4.5v-8.953zM18.375 13.922l-4.875 4.5v3.328h-3v-3.328l-4.875-4.5v-6.797h12.75z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-input-power.js
// module id = null
// module chunks = 